var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var SearchBuilderController = /** @class */ (function () {
            /** @ngInject **/
            function SearchBuilderController($scope, $http, properties) {
                var _a;
                var _this = this;
                this.$scope = $scope;
                this.$http = $http;
                this.properties = properties;
                this.logicalOperators = [pesquisaAvancada.LogicalOperator.MUST, pesquisaAvancada.LogicalOperator.SHOULD, pesquisaAvancada.LogicalOperator.MUST_NOT];
                this.comparisonOperators = (_a = {},
                    _a[pesquisaAvancada.ComparisonOperator.EQUALS] = ["keyword", "number", "currency", "list"],
                    _a[pesquisaAvancada.ComparisonOperator.CONTAINS] = ["string"],
                    _a[pesquisaAvancada.ComparisonOperator.BETWEEN] = ["number", "currency", "date"],
                    _a[pesquisaAvancada.ComparisonOperator.GREATER_THAN] = ["number", "currency", "date"],
                    _a[pesquisaAvancada.ComparisonOperator.LESS_THAN] = ["number", "currency", "date"],
                    _a[pesquisaAvancada.ComparisonOperator.EXISTS] = ["constant", "string", "keyword", "number", "currency", "date", "list"],
                    _a);
                this.traitSearchText = "";
                this.newCriterion = new pesquisaAvancada.Criterion();
                $scope.traits.forEach(function (trait) { return _this.loadTraitValuesIfNeeded(trait); });
                this.traits = $scope.traits;
                this.search = $scope.search;
            }
            SearchBuilderController.prototype.setCriterionLogicalOperator = function (criterion, operator) {
                criterion.logicalOperator = operator;
            };
            SearchBuilderController.prototype.removeCriterion = function (i) {
                _.pullAt(this.search.criteria, i);
            };
            SearchBuilderController.prototype.querySearch = function (query) {
                return query ? _.filter(this.traits, this.createFilterFor(query)) : this.traits;
            };
            SearchBuilderController.prototype.addNewCriterion = function () {
                var trait = angular.copy(this.newCriterion.trait);
                var logicalOperator = angular.copy(this.newCriterion.logicalOperator);
                var criterion = new pesquisaAvancada.Criterion(logicalOperator, trait);
                this.search.criteria.unshift(criterion);
            };
            SearchBuilderController.prototype.selectedItemChange = function (item) {
                if (!item) {
                    return;
                }
                this.addNewCriterion();
            };
            SearchBuilderController.prototype.cleanSelection = function (e) {
                if (!e.charCode) {
                    this.traitSearchText = "";
                }
            };
            SearchBuilderController.prototype.getComparisonOperators = function (dataType) {
                var operatorMapping = this.comparisonOperators;
                var ops = _.keys(operatorMapping);
                return _.reject(ops, function (op) { return !_.includes(operatorMapping[op], dataType); });
            };
            SearchBuilderController.prototype.createFilterFor = function (query) {
                var lowercaseQuery = _.deburr(angular.lowercase(query));
                return function (trait) { return (_.deburr(trait.name.toLowerCase()).indexOf(lowercaseQuery) !== -1); };
            };
            SearchBuilderController.prototype.loadTraitValuesIfNeeded = function (trait) {
                if (trait.api && !trait.values) {
                    trait.values = [];
                    this.$http.get(this.properties.apiUrl + trait.api, { cache: true })
                        .then(function (response) {
                        response.data.forEach(function (item) {
                            var id = trait.apiIdLowercase ? _.toLower(item[trait.apiId]) : item[trait.apiId];
                            var obj = new pesquisaAvancada.TraitListItem(id, item[trait.apiValue]);
                            trait.values.push(obj);
                        });
                    });
                }
            };
            return SearchBuilderController;
        }());
        pesquisaAvancada.SearchBuilderController = SearchBuilderController;
        angular
            .module("app.pesquisa-avancada")
            .controller("app.pesquisa-avancada.SearchBuilderController", SearchBuilderController);
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));
